import { Pipe, PipeTransform } from '@angular/core';
import { toString } from 'lodash';

@Pipe({
  name: 'toString',
  standalone: true,
})
export class ToStringPipe implements PipeTransform {
  transform(value: unknown): string {
    return toString(value);
  }
}
